<template>
  <!-- Popup Deposit -->
  <el-dialog
    title="Deposit"
    :visible.sync="isShowDepositForm"
    class="medium wallet-dialog"
    :close-on-click-modal="false"
    >
    <div class="popup-inner" :class="{ 'loading': isProcessing }">
      <div class="item">
        <label>{{ $t('TEXT_WALLET') }}</label>
        <select v-model="selectedSymbol">
          <option v-for="balance in depositBalances" :value="balance.currency" :key="balance.currency">
            {{balance.currency}} ({{balance.name}})
          </option>
        </select>
      </div>
      <div class="item">
        <label>{{ $t('TEXT_AMOUNT') }} <span>({{selectedSymbol}})</span></label>
        <input type="text" v-model="form.amount" placeholder="Enter amount"
          @keyup.enter="openDeposit">
      </div>
      <div class="item item-submit">
        <el-button class="btn" :disabled="!isValidated || isProcessing" @click.prevent="openDeposit">{{ $t('BTN_DEPOSIT') }}</el-button>
      </div>
    </div>
  </el-dialog>
  <!-- End Popup Deposit -->
</template>

<script>
export default {
  data () {
    return {
      endTime: '',
      selectedSymbol: 'USDT',
      selectedBalance: {},
      form: {
        amount: ''
      },
      isProcessing: false,
      second: null
    }
  },
  computed: {
    web3 () {
      return this.$store.getters.web3
    },
    balances () {
      return this.$store.getters.balances
    },
    depositBalances () {
      return this.balances.filter(balance => {
        return balance.is_allow_deposit
      })
    },
    ieoBalancesActive () {
      return this.balances.filter(balance => {
        return balance.allowDeposit
      })
    },
    isShowDepositForm: {
      get () {
        return this.$store.getters.isShowDepositForm
      },
      set () {
        this.$store.dispatch('toggleDepositForm')
      }
    },
    isValidated () {
      return this.form.amount && !isNaN(this.form.amount) && parseFloat(this.form.amount) > 0
    }
  },
  watch: {
    ieoBalancesActive (n, o) {
      if (!this.selectedBalance.symbol && n.length) {
        this.selectedBalance = n[0]
        this.selectedSymbol = n[0].symbol
      }
    },
    selectedSymbol (symbol) {
      if (symbol) {
        this.selectedBalance = this.ieoBalancesActive.filter(temp => temp.symbol === symbol)[0]
      }
    }
  },
  methods: {
    endCountdown () {
      this.$store.dispatch('showErrorMsg', this.$t('TEXT_YOUR_SESSION_HAS_EXPIRED'))
      setTimeout(() => {
        this.isProcessing && this.$store.dispatch('logout')
      }, 1800)
    },
    async openDeposit () {
      if (!this.isValidated) return
      this.isProcessing = true
      const selectedBalance = this.depositBalances.filter(temp => temp.currency === this.selectedSymbol)[0]
      const data = {
        amount: this.form.amount,
        address: selectedBalance.address,
        currency: selectedBalance.currency,
        contract: selectedBalance.contract
      }
      await this.$store.dispatch('sendTransaction', data)
      this.isProcessing = false
    }
  }
}
</script>
